import { Tooltip } from "reactstrap";
import { useEditorContext } from "../../Wysiwyg";
import { getSelectedAttributes } from "../../utils/getSelectedAttributes";
import { useState } from "react";

const MIN_FONT_SIZE = 11;
const MAX_FONT_SIZE = 40;

const fontSizeOptionValues = Array.from({
  length: MAX_FONT_SIZE - MIN_FONT_SIZE + 1,
})
  .fill(0)
  .map((_, i) => i + MIN_FONT_SIZE);

const ToolbarFontSize = () => {
  const { editor } = useEditorContext();
  const currentFontSize = useCurrentFontSize(editor);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <Tooltip
        placement="top"
        isOpen={tooltipOpen}
        target="toolbar-font-size"
        toggle={toggle}
        trigger="hover focus-visible"
      >
        Betűméret
      </Tooltip>
      <div style={{ position: "relative" }} id="toolbar-font-size">
        {!currentFontSize && (
          <i
            className="fa fa-text-height"
            aria-hidden="true"
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-45%)",
              color: "black",
              pointerEvents: "none",
            }}
          />
        )}
        <select
          className="form-control"
          value=""
          onChange={(e) =>
            editor.chain().focus().setFontSize(Number(e.target.value)).run()
          }
        >
          <option value="" hidden>
            {currentFontSize}
          </option>
          {fontSizeOptionValues.map((fontSize) => (
            <option key={fontSize} value={fontSize}>
              {fontSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

function useCurrentFontSize(editor) {
  const allCurrentTextStyleAttrs = getSelectedAttributes(
    editor.state,
    "textStyle"
  );
  const isTextStyleAppliedToEntireSelection = !!editor?.isActive("textStyle");
  const currentFontSizes = allCurrentTextStyleAttrs.map(
    (attrs) => attrs.fontSize ?? null
  );
  if (!isTextStyleAppliedToEntireSelection) {
    currentFontSizes.push(null);
  }
  const numUniqueCurrentFontSizes = new Set(currentFontSizes).size;

  let currentFontSize;
  if (numUniqueCurrentFontSizes === 1) {
    currentFontSize = currentFontSizes[0];
  } else if (numUniqueCurrentFontSizes > 1) {
    currentFontSize = "";
  } else {
    currentFontSize = null;
  }

  return currentFontSize;
}

export default ToolbarFontSize;
